import { Image } from 'foundations-components/transitional/components/Image';

// @ts-ignore svg import
import ContentHubSvg from 'bender-url!./images/ContentHub.svg';
import { MERCH_CARD_PRODUCT_ICON_STYLE_PROPS, PRODUCT_PAGE_TITLE_PRODUCT_ICON_STYLE_PROPS } from './styleProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const ContentHubProductIcon = ({
  useCase = 'productPageTitle'
}) => {
  return /*#__PURE__*/_jsx(Image, Object.assign({
    src: ContentHubSvg
  }, useCase === 'productPageTitle' ? PRODUCT_PAGE_TITLE_PRODUCT_ICON_STYLE_PROPS : MERCH_CARD_PRODUCT_ICON_STYLE_PROPS));
};